import { IAvatar } from '~/types/models'
import { useDefaultLayoutVarsStore } from '~/stores/defaultLayoutVars'

export default defineNuxtPlugin(() => {
  const router = useRouter()

  function setMenuBarTitle({
    callingMn,
    avatar = null,
    prefix = null,
    title = null,
  }: {
    callingMn: string
    avatar: IAvatar | null
    prefix: string | null
    title: string | null
  }): void {
    const fn = `${callingMn} --> [plugins/setMenuBarTitle.ts] setMenuBarTitle |`
    const titleToUse = !title ? router.currentRoute.value.name : title

    // eslint-disable-next-line no-console
    console.debug(`${fn} Setting menu bar avatar to:`, avatar)
    useDefaultLayoutVarsStore().setMenuBarAvatar(avatar)

    // eslint-disable-next-line no-console
    console.debug(`${fn} Setting menu bar prefix to:`, prefix)
    useDefaultLayoutVarsStore().setMenuBarPrefix(prefix)

    // eslint-disable-next-line no-console
    console.debug(`${fn} Setting menu bar title to: '${titleToUse}'`)
    useDefaultLayoutVarsStore().setMenuBarTitle(titleToUse)
  }
  return { provide: { setMenuBarTitle } }
})
